export default "__VITE_ASSET__DNUrmm9R__"